import { Reveal } from "@/components/site/Reveal";

// Inner-page hero header
export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative overflow-hidden bg-slate-950 pt-36 pb-20 md:pt-44 md:pb-28" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/40" />
      </>
    )}
    <div className="container-x relative z-10">
      <Reveal>
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-[color:var(--brand-red)]" />
          <span className="eyebrow text-slate-300">{eyebrow}</span>
        </div>
        <h1 className="mt-5 max-w-4xl text-4xl font-extrabold leading-[1.05] text-white text-balance sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
